import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./FoodProfile.css";
//const url = process.env.REACT_APP_SERVER_URL || "https://food.stall-centralsoft.com";
const stallID = localStorage.getItem("stallID");
const username = localStorage.getItem("username");

const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='150' viewBox='0 0 200 150'%3E%3Crect width='200' height='150' fill='%23f8f9fa'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='14' fill='%236c757d'%3ENo Image%3C/text%3E%3C/svg%3E";


function FoodsProfile() {
  const [foods, setFoods] = useState([]);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [foodNo, setFoodNo] = useState("");
  const [foodName, setFoodName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState(0.0);
  const [prom_price, setPromPrice] = useState(0.0);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(PLACEHOLDER);
  const [editingID, setEditingID] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [fileSelected, setFileSelected] = useState(null);
  const fileInputRef = useRef(null);

  // FIXED: Simple and reliable image URL function
  const getImageUrl = (imagePath) => {
    if (!imagePath || imagePath === "null" || imagePath === "undefined") {
      return PLACEHOLDER;
    }

    // If it's already a full URL, return it
    if (imagePath.startsWith('http') || imagePath.startsWith('data:')) {
      return imagePath;
    }

    // Extract just the filename (remove "uploads/" prefix if present)
    let filename = imagePath;
    if (imagePath.includes('/')) {
      filename = imagePath.split('/').pop();
    }
    
    if (!filename) return PLACEHOLDER;

    // Return full URL with cache busting
    return `/uploads/${filename}?t=${Date.now()}`;
  };

  // Fetch foods
  const fetchFoods = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`/api/admin/foods`, { 
        params: { stallID } 
      });
      setFoods(res.data.foods || []);
    } catch (err) {
      console.error("Error fetching foods:", err);
      setMessage("Error loading foods");
    } finally {
      setLoading(false);
    }
  };

  // Fetch categories
  const fetchCategories = async () => {
    try {
      const res = await axios.get(`/api/admin/categories`, { 
        params: { stallID } 
      });
      setCategories(res.data.categories || []);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };
    // Function to handle button click and trigger file input



  useEffect(() => {
    fetchFoods();
    fetchCategories();
  }, []);

  // Handle form submission
 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const formData = new FormData();
    formData.append("stallID", stallID);
    formData.append("category", category);
    formData.append("foodNo", foodNo);
    formData.append("foodName", foodName);
    formData.append("description", description);
    formData.append("price", price);
    formData.append("prom_price", prom_price);

    // Keep old image name (optional)
    if (fileSelected) {
      formData.append("imageURL", fileSelected);
    }
   
    console.log("imageURL (fileSelected): "+fileSelected);
    // ✅ Correct: upload the new file as "image"
    if (image instanceof File) {
      formData.append("image", image);
    }
    console.log("image : "+image);
    const api = editingID
      ? axios.put(`/api/admin/foods/${editingID}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      : axios.post(`/api/admin/foods`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

    await api;

    setMessage("✅ Food saved!");
    resetForm();
    fetchFoods();
  } catch (err) {
    console.error("Save food error:", err);
    setMessage("❌ Error saving food");
  } finally {
    setLoading(false);
  }
};



  // FIXED: Handle edit with proper image URL
  const handleEdit = (food) => {
    console.log("Editing food Name:", food.foodName);
     console.log("Editing food Image:", food.foodName);
    setEditingID(food.id);
    setCategory(food.category || "");
    setFoodNo(food.foodNo || "");
    setFoodName(food.foodName || "");
    setDescription(food.description || "");
    setPrice(food.price || 0);
    setPromPrice(food.prom_price || 0);
    setImage(null);

    // FIXED: Set preview with proper image URL
    if (food.imageURL) {
      const imageUrl = getImageUrl(food.imageURL);
      console.log("Setting preview to:", imageUrl);
      setPreview(imageUrl);
      setFileSelected(food.imageURL)

    } else {
      setPreview(PLACEHOLDER);
    }
  };

  // Handle delete
  const handleDelete = async (id) => {
    //alert(id);
    if (!window.confirm("Are you sure you want to delete this food item?")) return;

    try {
      await axios.delete(`/api/admin/foods/${id}`);
      setMessage("🗑️ Food deleted successfully");
      fetchFoods();
    } catch (err) {
      console.error("Delete error:", err);
      setMessage("❌ Error deleting food");
    }
  };

  // Handle image change
  /*
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setPreview(objectUrl);
    } else {
      setPreview(PLACEHOLDER);
    }
  };
*/
 const handleFileButtonClick = () => {
    fileInputRef.current.click(); // Trigger the click event of the hidden input
      //alert("Selected from folder : "+image);
  };

const handleImageChange = (event) => {
  const file = event.target.files[0];
  alert(file);
  if (!file) return;

  if (!file.type.startsWith("image/")) {
    alert("Please select an image file.");
    return;
  }
 // alert("file selected fron dialog : "+file.name);
 setFileSelected(file.name);
 //alert('fileSelected :'+fileSelected);
 //alert('image: '+file);
  // ✅ Save actual File object, NOT file.name
  setImage(file);
  //alert('setImage : '+image);
  //alert("Selected from folder : "+JSON.stringify(event.target.file[0]));
  // Preview
  const previewUrl = URL.createObjectURL(file);
  setPreview(previewUrl);
};


/*
  const handleImageChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type.startsWith('image/')) {
      // Handle the selected image file here
      console.log('Selected image:', selectedFile);
      // You can also create a URL for preview:
      const imageUrl = URL.createObjectURL(selectedFile);
      //const objectUrl = URL.createObjectURL(selectedFile);
      console.log('Image URL:', imageUrl);
      // Update state to display the image preview, etc.
  if (!selectedFile) {
    setImage(null);
    setPreview(PLACEHOLDER);
    return;
  }

  setImage(selectedFile);
   // imageUrl = getImageUrl(food.imageURL);
      console.log("Setting selected preview to:", selectedFile);
      setPreview(imageUrl);

 //const objectUrl = URL.createObjectURL(selectedFile);
 // setPreview(objectUrl);

  console.log("Preview updated:", imageUrl);
};

 //   } else {
  //    console.log('Please select an image file.');
 //   }
  };
 */ 
  /*
  const handleImageChange = (e) => {
  const file = e.target.files[0];
  console.log("Image changed:", file);

  if (!file) {
    setImage(null);
    setPreview(PLACEHOLDER);
    return;
  }

  setImage(file);

  // Create preview URL
  const objectUrl = URL.createObjectURL(file);
  setPreview(objectUrl);

  console.log("Preview updated:", objectUrl);
};
*/
  // Reset form
  const resetForm = () => {
    setEditingID(null);
    setCategory("");
    setFoodNo("");
    setFoodName("");
    setDescription("");
    setPrice(0.0);
    setPromPrice(0.0);
    setImage(null);
    setPreview(PLACEHOLDER);
    setMessage("");
  };

  // Simple Image component for table
  const TableImage = ({ imageURL, alt }) => {
    const [src, setSrc] = useState(getImageUrl(imageURL));

    return (
      <img
        src={src}
        alt={alt}
        style={{
          width: "80px",
          height: "60px",
          objectFit: "cover"
        }}
        className="img-thumbnail"
        onError={() => setSrc(PLACEHOLDER)}
      />
    );
  };


  return (
    <div className="container mt-4">
      <h2>🍲 Foods Profile</h2>
      <p className="text-muted">
        Stall ID: <strong>{stallID}</strong> | Stall Name: <strong>{username}</strong>
      </p>

      {/* Message Alert */}
      {message && (
        <div className={`alert ${message.includes('❌') ? 'alert-danger' : 'alert-success'} alert-dismissible fade show`}>
          {message}
          <button type="button" className="btn-close" onClick={() => setMessage("")}></button>
        </div>
      )}

      {/* Add/Edit Form */}
      <div className="card p-4 mb-4 shadow-sm">
        <h5 className="card-title">
          {editingID ? "✏️ Edit Food Item" : "➕ Add New Food Item"}
        </h5>

        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label fw-bold">Category *</label>
                <select
                  className="form-select"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  required
                >
                  <option value="">-- Select Category --</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.categoryName}>
                      {cat.categoryName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Food ID *</label>
                <input
                  type="text"
                  className="form-control"
                  value={foodNo}
                  onChange={(e) => setFoodNo(e.target.value.toUpperCase())}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Food Name *</label>
                <input
                  type="text"
                  className="form-control"
                  value={foodName}
                  onChange={(e) => setFoodName(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Description *</label>
                <textarea
                  className="form-control"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows="3"
                  required
                />
              </div>
            </div>
  <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label fw-bold">Price (RM) *</label>
                <input
                  type="number"
                  className="form-control"
                  value={price}
                  onChange={(e) => setPrice(e.target.value === "" ? 0 : parseFloat(e.target.value))}
                  step="0.01"
                  min="0"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Promotion Price (RM)</label>
                <input
                  type="number"
                  className="form-control"
                  value={prom_price}
                 onChange={(e) => setPromPrice(e.target.value === "" ? 0 : parseFloat(e.target.value))}
                  step="0.01"
                  min="0"
                />
              </div>

<div className="mb-3">
  <label className="form-label fw-bold">
    Food Image {!editingID && '*'}
  </label>

 <input
  type="file"
  accept="image/*"
  ref={fileInputRef}
  // REPLACE the existing style prop with the following:
 style={{ 
    display: 'block', // MAKE IT VISIBLE
    opacity: 1,
    position: 'relative'
  }}
  onChange={handleImageChange}
/>
  <button
    type="button"
    className="btn btn-outline-primary w-100"
    onClick={handleFileButtonClick}
  >
    {image ? image.name : "Choose Image"}
  </button>

  <div className="form-text">
    {!editingID
      ? "Required for new items"
      : "Select new image to update current one"}
  </div>
</div>



              {/* Image Preview */}
              <div className="mb-3">
                <label className="form-label fw-bold">Image Preview</label>
                <div className="border rounded p-3 text-center bg-light">
                  <img
                    src={preview}
                    alt="Food preview"
                    style={{
                      maxWidth: "200px",
                      maxHeight: "150px",
                      objectFit: "contain"
                    }}
                    className="img-fluid"
                    onError={(e) => {
                      e.target.src = PLACEHOLDER;
                    }}
                  />
                  <div className="mt-2">
                    <small className={preview === PLACEHOLDER ? "text-danger" : "text-success"}>
                      {preview === PLACEHOLDER
                        ? "No image selected"
                        : image
                          ? "New image ready for upload"
                          : "Current food image"
                      }
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex gap-2 mt-3">
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "⏳ Processing..." : (editingID ? "Update Food" : "Add Food")}
            </button>
            {editingID && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={resetForm}
                disabled={loading}
              >
                Cancel Edit
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Foods List */}
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Food Items ({foods.length})</h5>
          {loading && <span className="spinner-border spinner-border-sm"></span>}
        </div>
        
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Food ID</th>
                  <th>Food Name</th>
                  <th>Category</th>
                  <th>Price</th>
                  <th>Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {foods.length > 0 ? (
                  foods.map((food) => (
                    <tr key={food.id}>
                      <td>{food.id}</td>
                      <td>
                        <code>{food.foodNo}</code>
                      </td>
                      <td>
                        <div>
                          <strong>{food.foodName}</strong>
                          {food.description && (
                            <div className="text-muted small mt-1">
                              {food.description}
                            </div>
                          )}
                        </div>
                      </td>
                      <td>{food.category}</td>
                      <td>RM {parseFloat(food.price).toFixed(2)}</td>
                      <td className="text-center">
                        <TableImage 
                          imageURL={food.imageURL} 
                          alt={food.foodName} 
                        />
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm">
                          <button
                            className="btn btn-outline-warning"
                            onClick={() => handleEdit(food)}
                            title="Edit food"
                            disabled={loading}
                          >
                            ✏️
                          </button>
                          <button
                            className="btn btn-outline-danger"
                            onClick={() => handleDelete(food.id)}
                            title="Delete food"
                            disabled={loading}
                          >
                            🗑️
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-5">
                      <div className="text-muted">
                        {loading ? "Loading food items..." : "No food items found. Add your first food item above."}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Debug Section - Remove after testing */}
     
    </div>
  );
}

export default FoodsProfile;